import React from 'react';
import {
  CAREER_OVERVIEW_HEADER,
  CAREER_OVERVIEW_SUBHEADER,
  CAREER_OVERVIEW_LIST,
  CAREER_OVERVIEW_IMAGE_SRC,
  CAREER_OVERVIEW_IMAGE_ALT,
} from '../../constants/Careers/index';
import './CareerOverview.css';
import image from './GoodTeam.png';

export const CareerOverview = () => (
  <>
    <div className="overview-container">
      <div className="overview-content">
        <h2 className="overview-header">{CAREER_OVERVIEW_HEADER}</h2>
        <h5 className="overview-subheader">{CAREER_OVERVIEW_SUBHEADER}</h5>

        <div className="overview-list">
          {CAREER_OVERVIEW_LIST.map((overview) => (
            <div className="overview" key={overview.text}>
              <h3 className="overview-number">{overview.number}</h3>
              <p className="overview-text">{overview.text}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="overview-image">
        <img src={image} alt={CAREER_OVERVIEW_IMAGE_ALT} className="overview-img" />
      </div>
    </div>
  </>
);
